<div class="page-layout blank fullwidth p-12" fusePerfectScrollbar>
    <h2 class="shipping-charges-title">Shipping Charges</h2>

    <p>Add services worth Rs.2000 to get FREE delivery !</p>

    <div>
        <button mat-raised-button class="close-popup" (click)="closePopup()">Got it</button> 
    </div>
</div>